import { useInfiniteQuery } from '@northladder/services';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';
import { IFetchDealsUrlOptions } from '../types';

/**
 * This is to track the deal details mutation keys in react query cache.
 */
export const FETCH_DEALS_QUERY = 'fetch-deals-query-key';

/**
 * This hook will call deals list api.
 */
export const useDealsListQuery = (queryParams: IFetchDealsUrlOptions) => {
  const {
    brandIds = [],
    categoryId = '',
    count,
    field: searchFilter = '',
    filters = '',
    fromDate = '',
    groupIds = [],
    orderBy,
    page,
    searchText: appraisalCode = '',
    sortBy,
    toDate = '',
  } = queryParams;

  /**
   * This is to ensure that the `queryKey` does not
   * contain any null or undefined values to make sure that the key is unique.
   */
  const queryKey = [
    FETCH_DEALS_QUERY,
    appraisalCode,
    brandIds,
    categoryId,
    count,
    filters,
    fromDate,
    groupIds,
    orderBy,
    searchFilter,
    sortBy,
    toDate,
  ];
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey,
    networkMode: 'always',
    retry: false,
    initialPageParam: 1,
    queryFn: ({ pageParam = page || 1 }) =>
      CUSTOMER_SERVICE_API.fetchDealsList({ ...queryParams, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const loadedItems = allPages.reduce(
        (acc, pageNumber) => acc + pageNumber.appraisals.length,
        0
      );

      if (loadedItems >= lastPage.count) return undefined;

      return allPages.length + 1;
    },
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  };
};
